/* hod-softnav.js — collection → collection without a full page load (roadmap 3.9.3 K.1; built 10/6 on a test draft,
   reviewed, then copied to live).
   A click on a link to another /collections/<handle> page (quick-nav tiles, pill rails, pagination, mega menu, phone
   drawer) fetches that page in the background, swaps everything between the header and the footer (<main>) plus the
   top bar, patches the title / canonical / meta, pushes the URL, scrolls to the top, re-runs the page's own section
   scripts and tells theme.js to rebuild the collection component the way the theme editor does
   (shopify:section:unload / :load). The theme's thin orange loading bar shows while the page is fetched; after 250 ms
   the old page dims so a slow fetch has visible feedback. Hover (or a settled touch) prefetches so a click is near-instant.
   Normal navigation instead when: the fetch fails or takes longer than 5 s, the target page carries a countdown / hero /
   Get Inspired carousel (their scripts only initialise on a real load — the Sale template and the Forno sale page; those
   URLs are remembered and never intercepted again), a modifier key or non-left click, a new-tab link, the theme editor,
   or the page is not a collection page. Back / Forward between collection entries is soft (every collection history
   entry is tagged hodSoftNav; custom.js skips its reload for them, theme.js's own collection reload is suppressed for
   them). Analytics: Shopify's page_viewed only fires on real loads; the custom event "hod_soft_navigation" is published
   for custom pixels. Exposes window.hodSoftNav.go(url) for other scripts (menu rows). */
(function () {
  'use strict';
  if (window.__hodSoftNav) return;
  window.__hodSoftNav = true;
  if (window.Shopify && window.Shopify.designMode) return;
  if (!('fetch' in window) || !('DOMParser' in window) || !window.history || !('pushState' in window.history)) return;
  var main = document.getElementById('main');
  if (!main) return;

  var HARD = ['data-hp-countdown', 'data-hp-insp', 'data-hp-hero'];
  var PATH = /^\/collections\/[^/]+\/?$/;
  var CACHE_TTL = 300000, IDLE_TTL = 120000, CACHE_MAX = 8, TIMEOUT = 5000;   /* 10/6 K.4: hover/touch 5 min, idle preloads 2 min, 8 pages (was 60 s / 4) */
  var cache = new Map();
  var hardUrls = {};
  ['/collections/sale', '/collections/forno-special-sale'].forEach(function (p) { hardUrls[location.origin + p] = 1; });
  var navToken = 0, inflight = null, rendered = location.href;
  var conn = navigator.connection || {};
  var saveData = !!(conn.saveData || /2g/.test(conn.effectiveType || ''));

  function onCollection() { return document.body.classList.contains('template-collection'); }
  function hasHard(root) { for (var i = 0; i < HARD.length; i++) if (root.querySelector('[' + HARD[i] + ']')) return true; return false; }

  function eligible(a, e) {
    if (!a || !a.getAttribute('href')) return null;
    if (e && (e.defaultPrevented || e.button !== 0 || e.metaKey || e.ctrlKey || e.shiftKey || e.altKey)) return null;
    if (a.target && a.target !== '_self') return null;
    if (a.hasAttribute('download') || a.hasAttribute('data-no-softnav')) return null;
    if (a.closest('[data-no-softnav], form')) return null;
    var u;
    try { u = new URL(a.getAttribute('href'), location.href); } catch (err) { return null; }
    if (u.origin !== location.origin || !PATH.test(u.pathname)) return null;
    if (u.pathname === location.pathname && u.search === location.search) return null;
    if (hardUrls[u.href] || hardUrls[u.origin + u.pathname]) return null;
    return u.href;
  }

  function fresh(url) { var h = cache.get(url); return !!h && Date.now() - h.t < (h.idle ? IDLE_TTL : CACHE_TTL); }
  function remember(url, res) {
    cache.set(url, res);
    while (cache.size > CACHE_MAX) cache.delete(cache.keys().next().value);
  }

  /* isIdle: an idle preload (K.4). A click or hover that adopts an inflight idle fetch clears the tag, so a later
     hover cannot abort the fetch the navigation is waiting on (review 10/6). */
  function load(url, isIdle) {
    if (fresh(url)) return Promise.resolve(cache.get(url));
    cache.delete(url);
    if (inflight && inflight.url === url) { if (!isIdle) inflight.idle = false; return inflight.p; }
    if (inflight && inflight.ctl) { try { inflight.ctl.abort(); } catch (e) {} }
    var ctl = ('AbortController' in window) ? new AbortController() : null;
    var p = fetch(url, { credentials: 'same-origin', headers: { 'X-HOD-SoftNav': '1' }, signal: ctl ? ctl.signal : undefined }).then(function (r) {
      if (!r.ok || !/text\/html/.test(r.headers.get('content-type') || '')) throw new Error('softnav: bad response');
      return r.text().then(function (html) { var res = { html: html, url: r.url || url, t: Date.now() }; remember(url, res); return res; });
    });
    inflight = { url: url, p: p, ctl: ctl, idle: !!isIdle };
    var done = function () { if (inflight && inflight.p === p) inflight = null; };
    p.then(done, done);
    return p;
  }

  function runScripts(root) {
    if (!root) return;
    root.querySelectorAll('script').forEach(function (old) {
      if (old.type && !/javascript|module|^$/.test(old.type)) return;   /* json / templates stay */
      var defs = old.text.match(/customElements\.define\(\s*['"]([\w-]+)['"]/g);
      if (defs && defs.every(function (d) { var name = d.match(/['"]([\w-]+)['"]/)[1]; return window.customElements && window.customElements.get(name); })) return;
      if (old.src) {
        var already = Array.prototype.some.call(document.scripts, function (s) { return s !== old && s.src === old.src; });
        if (already) { old.remove(); return; }
      }
      var s = document.createElement('script');
      Array.prototype.forEach.call(old.attributes, function (at) { s.setAttribute(at.name, at.value); });
      s.text = old.text;
      old.parentNode.replaceChild(s, old);
    });
  }

  function patchHead(doc) {
    var t = doc.querySelector('head > title');
    if (t) document.title = t.textContent;
    ['link[rel="canonical"]', 'meta[name="description"]', 'meta[property="og:title"]', 'meta[property="og:url"]', 'meta[property="og:image"]', 'meta[property="og:description"]', 'meta[name="twitter:title"]', 'meta[name="twitter:description"]'].forEach(function (sel) {
      var o = document.head.querySelector(sel), n = doc.head.querySelector(sel);
      if (!o || !n) return;
      if (o.tagName === 'LINK') o.setAttribute('href', n.getAttribute('href')); else o.setAttribute('content', n.getAttribute('content') || '');
    });
    var nb = (doc.body.className.match(/(?:^|\s)(product-[\w-]*)/) || [])[1];
    var ob = (document.body.className.match(/(?:^|\s)(product-[\w-]*)/) || [])[1];
    if (nb !== undefined && ob !== undefined && nb !== ob) document.body.classList.replace(ob, nb);
  }

  function drawerOpen() { var mm = document.getElementById('mobile-menu'); return !!(mm && mm.getAttribute('aria-hidden') === 'false'); }
  function closeDrawer() { var c = document.querySelector('.hod-mm__close') || document.querySelector('[data-action="toggle-menu"][aria-controls="mobile-menu"]'); if (c && drawerOpen()) { try { c.click(); } catch (e) {} } }   /* 10/6: the drawer's own close button only exists once the lazy drawer is injected; the header toggle is the fallback */

  function swap(res, opts) {
    var fu;
    try { fu = new URL(res.url, location.href); } catch (e) { return false; }
    if (fu.origin !== location.origin || !PATH.test(fu.pathname)) return false;
    var doc = new DOMParser().parseFromString(res.html, 'text/html');
    var newMain = doc.getElementById('main');
    if (!newMain || !doc.body.classList.contains('template-collection') || !newMain.querySelector('[data-section-type="collection"]')) return false;
    if (hasHard(newMain)) { hardUrls[fu.href] = 1; hardUrls[fu.origin + fu.pathname] = 1; return false; }

    main.querySelectorAll('[data-section-id][data-section-type]').forEach(function (s) {
      document.dispatchEvent(new CustomEvent('shopify:section:unload', { detail: { sectionId: s.getAttribute('data-section-id') } }));
    });
    var qvClose = document.querySelector('.hqv-shell [data-hqv-close]');
    if (qvClose) { try { qvClose.click(); } catch (e) {} }

    var frag = document.createDocumentFragment();
    while (newMain.firstChild) frag.appendChild(newMain.firstChild);
    main.innerHTML = '';
    main.appendChild(frag);

    var tb = document.getElementById('shopify-section-hod-topbar'), ntb = doc.getElementById('shopify-section-hod-topbar');
    if (tb && ntb) tb.innerHTML = ntb.innerHTML;

    patchHead(doc);
    if (opts.push) history.pushState({ hodSoftNav: true, scrollY: 0 }, '', res.url);
    rendered = location.href;
    window.scrollTo(0, opts.scrollY || 0);

    runScripts(main);
    if (tb && ntb) runScripts(tb);
    main.querySelectorAll('[id^="shopify-section-"]').forEach(function (w) {
      w.dispatchEvent(new CustomEvent('shopify:section:load', { bubbles: true, detail: { sectionId: w.id.replace('shopify-section-', '') } }));
    });
    closeDrawer();
    handoffPrefetch(main);
    if (typeof window.hodRailArrows === 'function') { try { window.hodRailArrows(); } catch (e) {} }
    if (typeof window.hodFilterEnhance === 'function') { try { window.hodFilterEnhance(); } catch (e) {} }
    if (typeof window.hodSpotlightInit === 'function') window.hodSpotlightInit();
    if (typeof window.hodFractionalStars === 'function') { window.hodFractionalStars(); setTimeout(window.hodFractionalStars, 250); }
    var h = main.querySelector('h1');
    var focusEl = h || main;
    focusEl.setAttribute('tabindex', '-1');
    try { focusEl.focus({ preventScroll: true }); } catch (e) {}
    document.dispatchEvent(new CustomEvent('hod:softnav:swapped', { detail: { url: res.url } }));
    if (window.Shopify && window.Shopify.analytics && typeof window.Shopify.analytics.publish === 'function') {
      try { window.Shopify.analytics.publish('hod_soft_navigation', { url: res.url, title: document.title }); } catch (e) {}
    }
    if (typeof window.hodAnnounce === 'function') window.hodAnnounce(document.title);
    return true;
  }

  function handoffPrefetch(root) {
    (root || document).querySelectorAll('a[data-instant][href^="/collections/"]').forEach(function (a) {
      if (PATH.test(a.pathname || '')) a.removeAttribute('data-instant');
    });
  }

  function busy(on) {
    document.documentElement.classList.toggle('hod-softnav-busy', !!on);
    if (on) main.setAttribute('aria-busy', 'true'); else main.removeAttribute('aria-busy');
  }
  function hard(url, opts, why) { busy(false); try { if (window.console && window.__hodSoftNavDebug) console.debug('softnav: hard navigation', why || '', url); } catch (e) {} if (opts && opts.pop) location.reload(); else location.assign(url); }

  function go(url, opts) {
    opts = opts || {};
    var token = ++navToken;
    document.dispatchEvent(new CustomEvent('theme:loading:start'));
    busy(true);
    var late = setTimeout(function () { if (token === navToken) { navToken++; hard(url, opts, 'timeout'); } }, TIMEOUT);
    load(url).then(function (res) {
      clearTimeout(late);
      if (token !== navToken) return;
      var ok = false;
      try { ok = swap(res, opts); } catch (e) { ok = false; }
      busy(false);
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      if (!ok) hard(url, opts, 'swap refused');
    }).catch(function (err) {
      clearTimeout(late);
      if (token !== navToken) return;
      document.dispatchEvent(new CustomEvent('theme:loading:end'));
      /* an abort while THIS navigation is still current means something else cancelled our fetch — never leave the
         page stuck busy (review 10/6) */
      hard(url, opts, (err && err.name === 'AbortError') ? 'fetch aborted' : 'fetch failed: ' + (err && err.message));
    });
  }

  function tagEntry() {
    var st = history.state || {};
    if (st.hodSearch) return;
    if (!st.hodSoftNav || st.scrollY !== window.scrollY) history.replaceState(Object.assign({}, st, { hodSoftNav: true, scrollY: window.scrollY }), '', location.href);
  }

  /* own the scroll position of every collection entry */
  try { history.scrollRestoration = 'manual'; } catch (e) {}
  var scrollT = null;
  window.addEventListener('scroll', function () {
    if (scrollT || !onCollection()) return;
    scrollT = setTimeout(function () { scrollT = null; tagEntry(); }, 250);
  }, { passive: true });
  tagEntry();

  document.addEventListener('click', function (e) {
    if (!onCollection()) return;
    var a = e.target.closest('a[href]');
    var href = eligible(a, e);
    if (!href) return;
    e.preventDefault();
    tagEntry();
    if (a.closest('#mobile-menu')) closeDrawer();
    go(href, { push: true });
  });

  /* prefetch on intent: hover (65 ms, like instant.page) or a touch that does not turn into a scroll */
  var hoverT = null, touchT = null;
  if (!saveData) {
    document.addEventListener('mouseover', function (e) {
      if (!onCollection()) return;
      var a = e.target.closest('a[href]'); var href = eligible(a);
      if (!href || fresh(href)) return;
      clearTimeout(hoverT);
      hoverT = setTimeout(function () { if (!inflight || inflight.idle) load(href).catch(function () {}); }, 65);
    }, { passive: true });
    document.addEventListener('mouseout', function (e) { if (e.target.closest && e.target.closest('a[href]')) clearTimeout(hoverT); }, { passive: true });
    document.addEventListener('touchstart', function (e) {
      if (!onCollection()) return;
      var a = e.target.closest && e.target.closest('a[href]'); var href = eligible(a);
      if (!href || fresh(href)) return;
      clearTimeout(touchT);
      touchT = setTimeout(function () { if (!inflight || inflight.idle) load(href).catch(function () {}); }, 100);
    }, { passive: true });
    document.addEventListener('touchmove', function () { clearTimeout(touchT); }, { passive: true });
  }

  /* 10/6 (3.9.3 K.4): idle preload of the rail links on screen — quick nav tiles, pill rows, brand / series / zone
     tiles. Desktop only (hover-capable fine pointer, no Save-Data / reduced-data), after the page has fully loaded plus
     a pause, one plain collection page at a time, at most IDLE_MAX per rendered collection, cancelled by the next
     swap (idleGen). An idle fetch is tagged so a hover or click takes over (load() aborts an inflight fetch for another
     URL); idle entries expire after IDLE_TTL. Phones keep the touch prefetch only. */
  var IDLE_MAX = 5, IDLE_DELAY = 1500, idleT = null, idleGen = 0, idleRic = null;
  var finePointer = !!(window.matchMedia && window.matchMedia('(hover: hover) and (pointer: fine)').matches);
  var reducedData = !!(window.matchMedia && window.matchMedia('(prefers-reduced-data: reduce)').matches);
  function idleTargets() {
    var seen = {}, out = [], vh = window.innerHeight || 800;
    var links = document.querySelectorAll('#main .hod-btiles a[href], #main .hod-crail a[href], #main .hod-qnav a[href], #main .hod-btile[href]');
    for (var i = 0; i < links.length && out.length < IDLE_MAX; i++) {
      var a = links[i], href = eligible(a);
      if (!href || seen[href] || fresh(href)) continue;
      if (href.indexOf('?') !== -1) continue;                      /* plain collection pages only — no filtered renders */
      var r = a.getBoundingClientRect();                            /* on screen (or just below the fold) only */
      if (r.bottom < 0 || r.top > vh * 1.25) continue;
      seen[href] = 1; out.push(href);
    }
    return out;
  }
  function idlePrefetch() {
    if (saveData || reducedData || !finePointer || !onCollection() || document.hidden) return;
    var gen = ++idleGen, list = idleTargets();
    (function next() {
      if (gen !== idleGen || !list.length || !onCollection() || document.hidden) return;
      if (inflight) { setTimeout(next, 400); return; }
      var href = list.shift();
      load(href, true).then(function (res) { if (res && gen === idleGen) res.idle = true; }).catch(function () {}).then(function () { setTimeout(next, 150); });
    })();
  }
  function scheduleIdle() {
    clearTimeout(idleT); idleGen++;                                 /* cancel the previous page's loop */
    if (idleRic && 'cancelIdleCallback' in window) { try { window.cancelIdleCallback(idleRic); } catch (e) {} }
    idleT = setTimeout(function () {
      if ('requestIdleCallback' in window) idleRic = window.requestIdleCallback(idlePrefetch, { timeout: 2000 }); else idlePrefetch();
    }, IDLE_DELAY);
  }
  if (!saveData && !reducedData && finePointer) {
    if (document.readyState === 'complete') scheduleIdle(); else window.addEventListener('load', scheduleIdle, { once: true });
    document.addEventListener('hod:softnav:swapped', scheduleIdle);
  }

  /* theme.js pushes its own history entries for filter / sort / page changes (untagged) — tag them so Back and
     Forward across them stay soft. The mobile search's own entry (hodSearch) is left alone. */
  var _push = history.pushState;
  history.pushState = function (state, title, url) {
    if (onCollection() && !(state && state.hodSearch) && (!state || !state.hodSoftNav)) {
      tagEntry();
      state = Object.assign({}, state || {}, { hodSoftNav: true, scrollY: 0, themeEntry: true });
      try { rendered = new URL(url || location.href, location.href).href; } catch (e) {}
    }
    return _push.call(history, state, title, url);
  };

  /* theme.js: CollectionSection re-fetches its section on every popstate and never unregisters that listener; with
     soft navigation the tagged entries are ours, and detached instances must not fetch or scroll. */
  if (window.CollectionSection && window.CollectionSection.prototype && window.CollectionSection.prototype._reload) {
    var _rl = window.CollectionSection.prototype._reload;
    window.CollectionSection.prototype._reload = function (push) {
      if (push === false && ((history.state && history.state.hodSoftNav) || !(this.element && this.element.isConnected))) return;
      return _rl.apply(this, arguments);
    };
  }
  if (window.CollectionFilterDrawer && window.CollectionFilterDrawer.prototype && window.CollectionFilterDrawer.prototype._computeDrawerHeight) {
    var _ch = window.CollectionFilterDrawer.prototype._computeDrawerHeight;
    window.CollectionFilterDrawer.prototype._computeDrawerHeight = function () {
      if (!document.getElementById('mobile-collection-filters')) return;
      return _ch.apply(this, arguments);
    };
  }

  window.addEventListener('popstate', function (e) {
    if (!(e.state && e.state.hodSoftNav)) return;
    if (location.href === rendered) return;               /* same document (mobile search closed, hash) — nothing to swap */
    if (hasHard(main)) { location.reload(); return; }    /* leaving a countdown / hero page: real load */
    go(location.href, { push: false, pop: true, scrollY: e.state.scrollY || 0 });
  });

  handoffPrefetch(document);
  window.hodSoftNav = { go: function (url) { if (!onCollection()) { location.assign(url); return; } tagEntry(); go(url, { push: true }); } };
})();
